require('./brokerSearchResults.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { Prompt } = require('react-router-dom');
const { connect } = require('react-redux');

// @constants
const {
    TYPE_STOCKS,
    TYPE_PLANS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_ETFS,
    MYPROFILE_BROKER_ERROR_URL,
    BROKER_FUNDS_INTERNAL_TRANSFER_CUSTOM_CATEGORY_ID3_NO_VISIBLE,
} = require('constants/index');

// @local
const fundsTable = require('./typeTables/fundsResultsTable');
const { BrokerAdvancedSearchStocksResultsTable } = require('./typeTables/stocksResultsTable');
const plansTable = require('./typeTables/plansResultsTable');
const { BrokerAdvancedSearchETFsResultsTable } = require('./typeTables/etfsResultsTable');
const { BrokerAdvancedSearchWarrantsResultsTable } = require('./typeTables/warrantsResultsTable');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { ContentBox } = require('commonsComponents/contentBox');
const MorningStarCopyright = require('components/commons/morningStarCopyright/morningStarCopyright');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKMessage } = require('commonsComponents/OKMessage');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');

// @actions
const advancedSearchActions = require('actions/brokerAdvancedSearch');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const BrokerWatchlistActions = require('actions/brokerWatchlist');

// @components
const BrokerWatchlistModal = require('components/broker/brokerWatchlistModal/brokerWatchlistModal');
const { withRouter } = require('react-router-dom');

class BrokerSearchResults extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextLocation: null,
            isBlockingRouteChange: false
        };

        this.buildEmptyStateComponent = this.buildEmptyStateComponent.bind(this);
        this.buildMorningStarDisclaimer = this.buildMorningStarDisclaimer.bind(this);
        this.buildLoadingSection = this.buildLoadingSection.bind(this);
        this.morningStarDisclaimer = this.morningStarDisclaimer.bind(this);
        this.resultsTable = this.resultsTable.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handleProductBuy = this.handleProductBuy.bind(this);
        this.handleWatchlistModal = this.handleWatchlistModal.bind(this);
        this.saveListName = this.saveListName.bind(this);
        this.createNewList = this.createNewList.bind(this);
        this.cancelWatchlistModal = this.cancelWatchlistModal.bind(this);
        this.onCancelForNewList = this.onCancelForNewList.bind(this);
        this.onSubmitExistingList = this.onSubmitExistingList.bind(this);
        this.onSubmitNewList = this.onSubmitNewList.bind(this);
        this.handleWatchlistModalToggle = this.handleWatchlistModalToggle.bind(this);
        this.handleProductDetailsSelected = this.handleProductDetailsSelected.bind(this);
        this.deleteProductFromList = this.deleteProductFromList.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, resetWatchlistDetails, getUserWatchlist } = this.props;

        if (immFlagBasedFeatures.get('watchlist-enabled')) {
            resetWatchlistDetails();
            getUserWatchlist();
        }
    }

    buildEmptyStateComponent() {
        const notAvailableResult = formatText('broker-searchResultsNotAvailableResult');

        return <EmptyState primaryText={notAvailableResult} iconType="search-wealth" />;
    }

    buildLoadingSection() {
        const className = this.props.isModal
            ? 'broker-search-results__modal-loading'
            : 'broker-search-results';
        return (
            <div className={className}>
                <ContentBox id="brokerSearchResults">
                    <LoadingSection />
                </ContentBox>
            </div>
        );
    }

    buildMorningStarDisclaimer() {
        const disclaimerText = formatText('morningStar-disclaimerValues');

        return (
            <div className="broker-search-results__content-disclaimer">
                <p className="broker-search-results__disclaimer-text">
                    {disclaimerText}
                </p>
                <div className="broker-search-results__copyright-text">
                    <MorningStarCopyright />
                </div>
            </div>
        );
    }

    buildFiscalWarning(activeProduct) {
        const { immBrokerAttentionPlanStartingModal } = this.props;
        const today = new Date();
        const initialDate = immBrokerAttentionPlanStartingModal.get('firstDate');
        const closeDate = immBrokerAttentionPlanStartingModal.get('endDate');

        if (activeProduct === TYPE_PLANS && (initialDate <= today) && (today <= closeDate)) {
            return (
                <div className="broker-search-results__disclaimer-personal-info">
                    <OKMessage type="informative" modifier="dark-bg">
                        <FormattedText value="brokerAttentionPlanStartingModal-fiscalDisclaimer" />
                    </OKMessage>
                </div>
            );
        }

        return null;
    }

    handleProductBuy(nextLink) {
        const { immbrokerClientWarningModal, showClientWarningModal, history } = this.props;
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');

        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: nextLink,
                    isBlockingRouteChange: true
                });
            } else {
                history.push(nextLink);
            }
        } else if (!isFetched && !isFetching) {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        }
        window.modalInstance = this;
    }

    saveListName(listName) {
        this.props.saveListName(listName);
    }

    createNewList() {
        this.props.createNewList();
    }

    cancelWatchlistModal() {
        this.props.resetWatchlistDetails();
    }

    handleProductDetailsSelected(isin, micCode, producttype, index) {
        const { watchlistId, productDetailsToList, watchlistModalToggle, addToExistingList } = this.props;
        productDetailsToList(isin, micCode, producttype, index);
        if (watchlistId) {
            addToExistingList(watchlistId);
        }
        watchlistModalToggle(true);
    }

    onCancelForNewList() {
        this.props.createNewList();
        this.cancelWatchlistModal();
    }

    onSubmitExistingList() {
        const { immFavoriteContent } = this.props;
        const selectedId = immFavoriteContent.get('listSelectedId');
        this.props.addToExistingList(selectedId);
    }

    onSubmitNewList() {
        this.props.submitNewListName();
        this.props.getUserWatchlist();
    }

    handleWatchlistModalToggle(id) {
        this.props.listSelected(id);
    }

    handleWatchlistModal() {
        const { immFavoriteContent } = this.props;
        const watchlistContent = immFavoriteContent.get('watchlistContent');
        const isModalOpen = immFavoriteContent.get('isModalOpen');
        const listName = immFavoriteContent.get('listName');
        const emptyWatchlist = immFavoriteContent.get('emptyWatchlist');
        const listSelectedId = immFavoriteContent.get('listSelectedId');

        if (watchlistContent.size > 0 && !emptyWatchlist) {
            return (
                <BrokerWatchlistModal
                    watchlistContent={watchlistContent}
                    isModalOpen={isModalOpen}
                    modifier={'addToList'}
                    handleNewListModal={this.createNewList}
                    handleCancelForModal={this.cancelWatchlistModal}
                    handleContinueForExistingList={this.onSubmitExistingList}
                    onChangeListSelected={this.handleWatchlistModalToggle}
                    listSelectedId={listSelectedId}
                />
            )
        } else {
            return (
                <BrokerWatchlistModal
                    watchlistContent={watchlistContent}
                    isModalOpen={isModalOpen}
                    modifier={'createNewList'}
                    saveListName={this.saveListName}
                    listName={listName}
                    handleCancelForModal={this.onCancelForNewList}
                    handleContinueForNewList={this.onSubmitNewList}
                />
            )
        }
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    deleteProductFromList(id, isin, micCode, productName, status, deleteProduct, producttype, productKey) {
        this.props.deleteProductFromList(
            id,
            isin,
            micCode,
            productName,
            status,
            deleteProduct,
            producttype,
            productKey
        );
    }

    morningStarDisclaimer(activeProduct) {
        const disclaimerText = formatText('morningStar-disclaimerValues');
        let morningStarDisclaimer;
        if (activeProduct === TYPE_PLANS || activeProduct === TYPE_FUNDS) {
            return (
                <div className="broker-search-results__content-disclaimer">
                    <p className="broker-search-results__disclaimer-text">
                        {disclaimerText}
                    </p>
                    <div className="broker-search-results__copyright-text">
                        <MorningStarCopyright />
                    </div>
                </div>
            );
        }
        return morningStarDisclaimer;
    }

    resultsTable(activeProduct, results, checkedList, saveCheckedList, fromPlansTransfer, watchlistEnabled) {
        let ResultsTable;

        switch (activeProduct) {
            case TYPE_FUNDS:
                ResultsTable = fundsTable;
                break;
            case TYPE_STOCKS:
                ResultsTable = BrokerAdvancedSearchStocksResultsTable;
                break;
            case TYPE_ETFS:
                ResultsTable = BrokerAdvancedSearchETFsResultsTable;
                break;
            case TYPE_WARRANTS:
                ResultsTable = BrokerAdvancedSearchWarrantsResultsTable;
                break;
            case TYPE_PLANS:
                ResultsTable = plansTable;
                break;
            default:
                return;
        }

        const tableContent = (this.props.isModal
            ? (<ResultsTable
                results={results}
                checkedList={checkedList}
                saveCheckedList={saveCheckedList}
                isModal={this.props.isModal}
                onHandleProductSelect={this.handleProductSelect}
                onHandleProductBuy={this.handleProductBuy}
                onHandleWatchlistAdd={this.handleProductDetailsSelected}
                embeddedSearch={this.props.embeddedSearch}
                selectedNewFund={this.props.selectedNewFund}
                deleteProductFromList={this.deleteProductFromList}
                onSubmitExistingList={this.handleProductDetailsSelected}
                watchlistEnabled={watchlistEnabled}
                immExternalTransferFund={this.props.immExternalTransferFund}
                isExternalFundsTransfer={this.props.isExternalFundsTransfer}
                isInternalTransferFund={this.props.isInternalTransferFund}
            />)
            : (<ResultsTable
                fromPlansTransfer={fromPlansTransfer}
                selectedNewPlan={this.props.selectedNewPlan}
                results={results}
                checkedList={checkedList}
                saveCheckedList={saveCheckedList}
                onHandleProductBuy={this.handleProductBuy}
                onHandleWatchlistAdd={this.handleProductDetailsSelected}
                deleteProductFromList={this.deleteProductFromList}
                onSubmitExistingList={this.handleProductDetailsSelected}
                onHandleProductSelect={this.handleProductSelect}
                plansToFilter={this.props.plansToFilter}
                watchlistEnabled={watchlistEnabled}
            />));
        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div>
                    <BrokerClientWarningModal
                        nextLocation={this.state.nextLocation}
                        routerHookCallback={() => {
                            this.setState({ isBlockingRouteChange: false });
                        }}
                    />
                    {tableContent}
                </div>
            </React.Fragment>
        );
    }

    render() {
        const {
            searchState,
            saveCheckedList,
            embeddedSearch,
            fromPlansTransfer,
            immFlagBasedFeatures,
            plansToFilter,
            fundsToFilter,
            isInternalTransferFund,
        } = this.props;

        const watchlistEnabled = immFlagBasedFeatures.get('watchlist-enabled');
        const activeProduct = searchState.get('activeProduct');
        const results = searchState.get('resultsList');
        let showEmpty = searchState.get('showEmpty');
        const checkedList = searchState.get('checkedList');
        const hideBox = !showEmpty && results.size <= 0 ? '__hidden' : '';
        const watchlistModal = this.handleWatchlistModal();
        let resultsTable;
        let resultsEmpty;
        let warningFiscal;
        let filteredResults = results;

        if (searchState.get('isFetchingResults')) {
            return this.buildLoadingSection();
        }

        if (results.size > 0) {
            if (plansToFilter) {
                filteredResults = results.filter((plan) => {
                    return !plansToFilter.includes(plan.get('dgsCode'))
                });
            }

            if (fundsToFilter) {
                filteredResults = results.filter((fund) => {
                    return !fundsToFilter.includes(fund.get('ISIN'))
                });
            }

            if (isInternalTransferFund) {
                filteredResults = filteredResults.filter((fund) => {
                    return !!fund.get('customCategoryId3') &&
                        fund.get('customCategoryId3') !== BROKER_FUNDS_INTERNAL_TRANSFER_CUSTOM_CATEGORY_ID3_NO_VISIBLE;
                });
            }

            resultsTable = filteredResults.size > 0 ? this.resultsTable(activeProduct, filteredResults, checkedList, saveCheckedList, fromPlansTransfer, watchlistEnabled) : null;
            showEmpty = resultsTable === null;
        }

        if (showEmpty) {
            resultsEmpty = this.buildEmptyStateComponent();
        }

        let resultsTitle;

        if (activeProduct !== 'SIMPLE-SEARCH-PRODUCT') {
            resultsTitle = formatText('broker-advancedSearchResultsTitle');
        }

        warningFiscal = this.buildFiscalWarning(activeProduct);
        const titleStyle = hideBox
            ? 'broker-search-results__modal-display broker-search-results__hidden'
            : 'broker-search-results__modal-display';

        if (embeddedSearch) {
            return (
                <div>
                    {warningFiscal}
                    <div className={titleStyle}>
                        <ContentBox id="brokerSearchResults">
                            {resultsTable}
                            {resultsEmpty}
                        </ContentBox>
                    </div>
                </div>
            )
        }

        return this.props.isModal
            ? <div>
                {warningFiscal}
                <div className={titleStyle}>
                    <ContentBox id="brokerSearchResults" title={resultsTitle}>
                        {resultsTable}
                        {resultsEmpty}
                    </ContentBox>
                    {this.morningStarDisclaimer(activeProduct)}
                </div>
            </div>
            :
            <div>
                {warningFiscal}
                <div className={`broker-search-results${hideBox}`}>
                    <ContentBox id="brokerSearchResults" title={resultsTitle}>
                        {watchlistModal}
                        {resultsTable}
                        {resultsEmpty}
                    </ContentBox>
                    {this.morningStarDisclaimer(activeProduct)}
                </div>
            </div>;
    }
}

BrokerSearchResults.propTypes = {
    addToExistingList: PropTypes.func,
    createNewList: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    embeddedSearch: PropTypes.bool,
    getUserWatchlist: PropTypes.func,
    immFavoriteContent: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immbrokerClientWarningModal: PropTypes.object,
    immBrokerAttentionPlanStartingModal: PropTypes.object,
    isModal: PropTypes.bool,
    item: PropTypes.object,
    listSelected: PropTypes.func,
    onHandleProductSelect: PropTypes.func,
    productDetailsToList: PropTypes.func,
    resetWatchlistDetails: PropTypes.func,
    saveCheckedList: PropTypes.func,
    saveListName: PropTypes.func,
    searchState: PropTypes.object,
    selectedNewFund: PropTypes.string,
    selectedType: PropTypes.string,
    showClientWarningModal: PropTypes.func,
    submitNewListName: PropTypes.func,
    watchlistModalToggle: PropTypes.func,
    watchlistId: PropTypes.string,
    onHandlePlanSelect: PropTypes.func,
    fromPlansTransfer: PropTypes.bool,
    selectedNewPlan: PropTypes.string,
    plansToFilter: PropTypes.object,
    fundsToFilter: PropTypes.array,
    isExternalFundsTransfer: PropTypes.bool,
    immExternalTransferFund: PropTypes.object,
    isInternalTransferFund: PropTypes.bool,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerSearchResults;

module.exports = BrokerSearchResults;
module.exports.BrokerSearchResults = withRouter(connect(
    state => ({
        immFavoriteContent: state.brokerWatchlist,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immBrokerAttentionPlanStartingModal: state.brokerAttentionPlanStartingModal,
        searchState: state.brokerAdvancedSearch
    }),
    {
        addToExistingList: BrokerWatchlistActions.addToExistingList,
        createNewList: BrokerWatchlistActions.createNewList,
        deleteProductFromList: BrokerWatchlistActions.deleteProductFromList,
        getUserWatchlist: BrokerWatchlistActions.getUserWatchlist,
        listSelected: BrokerWatchlistActions.listSelected,
        productDetailsToList: BrokerWatchlistActions.productDetailsToList,
        resetWatchlistDetails: BrokerWatchlistActions.resetWatchlistDetails,
        saveCheckedList: advancedSearchActions.saveCheckedList,
        saveListName: BrokerWatchlistActions.saveListName,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        submitNewListName: BrokerWatchlistActions.newListName,
        watchlistModalToggle: BrokerWatchlistActions.watchlistModalToggle,
    }
)(BrokerSearchResults));
